import { render, staticRenderFns } from "./CaptureNationalFront.vue?vue&type=template&id=7ba2fc98&scoped=true&"
import script from "./CaptureNationalFront.vue?vue&type=script&lang=ts&"
export * from "./CaptureNationalFront.vue?vue&type=script&lang=ts&"
import style0 from "./CaptureNationalFront.vue?vue&type=style&index=0&id=7ba2fc98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba2fc98",
  null
  
)

export default component.exports